import { UnpaidInvoiceBanner } from "./UnpaidInvoiceBanner";

import { useSession } from "src/components/session/session";
import { useActiveContext } from "shared/ContextSwitcher/store";
import { useUnpaidInvoices, toInvoiceList } from "./useUnpaidInvoices";

import type { ReactElement } from "react";

type Output =
  | { status: "loading" | "dont-show" }
  | { status: "show"; banner: ReactElement };

export function useUnpaidInvoiceBanner(): Output {
  const session = useSession();
  const activeContext = useActiveContext();

  const unpaidInvoicesResult = useUnpaidInvoices(session, activeContext);

  if (!session || !activeContext || unpaidInvoicesResult.loading) {
    return { status: "loading" };
  }

  const unpaidInvoices = unpaidInvoicesResult.data
    ? toInvoiceList(unpaidInvoicesResult.data)
    : [];
  const hasUnpaidInvoice = unpaidInvoices.length > 0;

  if (hasUnpaidInvoice) {
    return {
      status: "show",
      banner: <UnpaidInvoiceBanner activeContext={activeContext} />,
    };
  } else {
    return { status: "dont-show" };
  }
}
